import { Link } from "react-router-dom";

const STATS = [
  { value: "10+", label: "Anos de Experiência", icon: "ri-award-line" },
  { value: "150+", label: "Projetos Realizados", icon: "ri-building-2-line" },
  { value: "120+", label: "Clientes Satisfeitos", icon: "ri-user-heart-line" },
];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-24" style={{ backgroundColor: "#F8F9FA" }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column – Decorative Stats Panel */}
          <div className="relative flex flex-col gap-6">
            {/* Main highlight card */}
            <div
              className="rounded-2xl p-10 flex flex-col items-center justify-center text-center"
              style={{ backgroundColor: "#1E3A8A", minHeight: "220px" }}
            >
              <p className="text-[#C9A24A] font-bold text-7xl leading-none mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
                10+
              </p>
              <p className="text-white font-semibold text-xl mb-2">Anos de Mercado</p>
              <p className="text-white/60 text-sm max-w-xs">
                Uma trajetória sólida construída com dedicação, técnica e confiança.
              </p>
            </div>

            {/* Two smaller stat cards */}
            <div className="grid grid-cols-2 gap-6">
              <div
                className="rounded-2xl p-7 flex flex-col items-center justify-center text-center"
                style={{ backgroundColor: "#121212" }}
              >
                <i className="ri-building-2-line text-[#C9A24A] text-3xl mb-2" />
                <p className="text-white font-bold text-4xl mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>150+</p>
                <p className="text-white/60 text-xs">Projetos Realizados</p>
              </div>
              <div
                className="rounded-2xl p-7 flex flex-col items-center justify-center text-center"
                style={{ backgroundColor: "#1F1F1F" }}
              >
                <i className="ri-user-heart-line text-[#C9A24A] text-3xl mb-2" />
                <p className="text-white font-bold text-4xl mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>120+</p>
                <p className="text-white/60 text-xs">Clientes Satisfeitos</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">
              Quem somos
            </span>
            <h2 className="text-[#1F1F1F] font-bold text-4xl md:text-5xl mb-6 leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Construlife<br />
              <span style={{ color: "#2563EB" }}>Engenharia e Arquitetura</span>
            </h2>
            <div className="w-16 h-1 mb-6" style={{ backgroundColor: "#C9A24A" }} />
            <p className="text-[#7A7A7A] text-[16px] leading-relaxed mb-5">
              Somos uma empresa especializada em engenharia e arquitetura, com atuação completa desde a concepção até a entrega do projeto. Nossa missão é transformar sonhos em estruturas reais com excelência técnica.
            </p>
            <p className="text-[#7A7A7A] text-[16px] leading-relaxed mb-8">
              Com uma equipe técnica qualificada e comprometida, oferecemos soluções personalizadas que unem inovação, funcionalidade e estética para cada cliente.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center p-4 bg-white rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2" style={{ color: "#2563EB" }}>
                    <i className={`${stat.icon} text-2xl`} />
                  </div>
                  <p className="text-[#2563EB] font-bold text-3xl" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    {stat.value}
                  </p>
                  <p className="text-[#7A7A7A] text-xs mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex justify-center md:justify-start">
              <Link
                to="/sobre"
                className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1E3A8A] text-white font-semibold px-7 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Conhecer a Empresa
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
